import { useState, useEffect } from "react";
import Guideline from "./components/Guideline";
import CheckQuality from "./components/CheckQuality";
import Verifying from "./components/Verifying";
import myprFrontGood from "../../assets/images/guideline-mypr-front-good.jpg";
import myprFrontBad from "../../assets/images/guideline-mypr-front-bad.jpg";
import myprBackGood from "../../assets/images/guideline-mypr-back-good.jpg";
import myprBackBad from "../../assets/images/guideline-mypr-back-bad.jpg";
import TakePhotoError from "./components/TakePhotoError";
import { useLocation } from "react-router-dom";
import InvalidToken from "./components/InvalidToken";
import { useMyPRService } from "./useMyPRService";
import UploadPhoto from "./components/UploadPhoto";
import MyPRReject from "./components/MyPRReject";
import MultipleReject from "./components/MultipleReject";
// import GuidelineSelfieWithMyPR from "./components/GuidelineSelfieWithMyPR";
// import CheckQualitySelfieWithMyPR from "./components/CheckQualitySelfieWithMyPR";
// import GuidelineHologramDetection from "./components/GuidelineHologramDetection";
// import CheckQualityHologramDetection from "./components/CheckQualityHologramDetection";
import ExceedMaxRetry from "./components/ExceedMaxRetry";
import EditNameModal from "./components/EditNameModal";
import EditIDNumberModal from "./components/EditIDNumberModal";

const MyPR = ({ validation, onComplete, onSessionUpdate }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token") || sessionStorage.getItem("ekycSessionToken");

  const {
    uploadFront,
    verifyFront,
    uploadBack,
    verifyBack,
    extractNameAndIDNumber,
  } = useMyPRService();

  const [step, setStep] = useState("mypr-front-guideline");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [validationID, setValidationID] = useState(null);
  const [hasMyPRFrontCheckCompleted, setHasMyPRFrontCheckCompleted] =
    useState(false);
  const [hasMyPRBackCheckCompleted, setHasMyPRBackCheckCompleted] =
    useState(false);
  // const [
  //   hasSelfieWithMyPRCheckCompleted,
  //   setHasSelfieWithMyPRCheckCompleted,
  // ] = useState(false);
  // const [
  //   hasHologramDetectionCheckCompleted,
  //   setHasHologramDetectionCheckCompleted,
  // ] = useState(false);

  const [progressStates, setProgressStates] = useState({
    myPRFront: "Not Started", // Not Started, Fail, Pass
    myPRBack: "Not Started",
    blacklist: "Not Started",
    kenalID: "Not Started",
    // selfieWithMyPR: "Not Started",
    // hologramDetection: "Not Started",
  });

  const [workflowConfig, setWorkflowConfig] = useState({});
  const [userUploadImageBuffer, setUserUploadImageBuffer] = useState(null);
  const [myPRFrontOriginalImageBlob, setMyPRFrontOriginalImageBlob] =
    useState(null);
  const [myPRFrontImageBlob, setMyPRFrontImageBlob] = useState(null);
  const [myPRBackOriginalImageBlob, setMyPRBackOriginalImageBlob] =
    useState(null);
  const [myPRBackImageBlob, setMyPRBackImageBlob] = useState(null);
  const [myPRHologramImageBlob, setMyPRHologramImageBlob] = useState(null);
  const [myPRHologramOriginalImageBlob, setMyPRHologramOriginalImageBlob] =
    useState(null);
  const [autofillFromOCR, setAutofillFromOCR] = useState(false);
  const [ocrName, setOcrName] = useState("");
  const [ocrIDNumber, setOcrIDNumber] = useState("");
  const [editNameModal, setEditNameModal] = useState(false);
  const [editIDNumberModal, setEditIDNumberModal] = useState(false);

  const [takePhotoErrorMessage, setTakePhotoErrorMessage] = useState("");

  useEffect(() => {
    if (validation) {
      const myPRResults =
        validation?.ComponentResults?.[validation.CurrentStep.ID] || {};
      const blacklistResult =
        validation?.ComponentResults?.[
          validation.CurrentStep.ID + "_Blacklist"
        ] || {};
      const kenalIDResult =
        validation?.ComponentResults?.[
          validation.CurrentStep.ID + "_KenalID"
        ] || {};
      // const selfieWithMyPRResult =
      //   validation?.ComponentResults?.[
      //     validation.CurrentStep.ID + "_SelfieWithMyPR"
      //   ] || {};
      // const hologramDetectionResult =
      //   validation?.ComponentResults?.[
      //     validation.CurrentStep.ID + "_MyPRHologram"
      //   ] || {};
      setProgressStates({
        myPRFront: myPRResults?.MyPRFrontResult
          ? myPRResults.MyPRFrontResult
          : "Not Started",
        myPRBack: myPRResults?.MyPRBackResult
          ? myPRResults.MyPRBackResult
          : "Not Started",
        blacklist: blacklistResult?.Result
          ? blacklistResult.Result
          : "Not Started",
        kenalID: kenalIDResult?.Result ? kenalIDResult.Result : "Not Started",
        // selfieWithMyPR: selfieWithMyPRResult?.Result
        //   ? selfieWithMyPRResult.Result
        //   : "Not Started",
        // hologramDetection: hologramDetectionResult?.Result
        //   ? hologramDetectionResult.Result
        //   : "Not Started",
      });

      const config = validation?.WorkflowConfigSnapshot?.Config?.[
        validation.CurrentStep.ID
      ].MyPRWorkflowConfig.IDVerification.reduce((acc, item) => {
        acc[item.name] = item["enabled"];
        return acc;
      }, {});
      setWorkflowConfig(config);
      setAutofillFromOCR(config["Autofill From OCR"]);
      setValidationID(validation?.ValidationID);
    }
  }, [validation]);

  // Check if validation record already exceeds max retry on initial load
  useEffect(() => {
    const overallResult = validation?.ComponentResults?.[validation.CurrentStep.ID]?.Result;
    if (
      validation?.ComponentResults?.[validation.CurrentStep.ID]
        ?.VALIDATION_COUNT >= 3 && 
      overallResult !== "Pass" &&
      overallResult !== "In Review"
    ) {
      setStep("exceed-max-retry");
    }
  }, [validation]);

  useEffect(() => {
    // let totalFail = 0;

    // if (progressStates.myPRFront === "Fail") {
    //   totalFail++;
    // }
    // if (progressStates.myPRBack === "Fail") {
    //   totalFail++;
    // }
    // if (progressStates.blacklist === "Fail") {
    //   totalFail++;
    // }
    // if (progressStates.kenalID === "Fail") {
    //   totalFail++;
    // }
    // // if (progressStates.selfieWithMyPR === "Fail") {
    // //   totalFail++;
    // // }
    // // if (progressStates.hologramDetection === "Fail") {
    // //   totalFail++;
    // // }

    // if (totalFail > 1) {
    //   return setStep("multiple-reject");
    // }

    // Check if exceeded max retry first - this takes priority over other conditions
    // Allow "Pass" and "In Review" to proceed
    const overallResult = validation?.ComponentResults?.[validation.CurrentStep.ID]?.Result;
    if (
      validation?.ComponentResults?.[validation.CurrentStep.ID]
        ?.VALIDATION_COUNT >= 3 && 
      overallResult !== "Pass" &&
      overallResult !== "In Review"
    ) {
      return setStep("exceed-max-retry");
    }

    // If overall result is "In Review", proceed to next step (treat like Pass for flow purposes)
    if (overallResult === "In Review") {
      if (onComplete) {
        onComplete({
          validationID: validation?.ValidationID,
        });
      }
      return;
    }

    if (
      progressStates.myPRFront === "Pending" ||
      progressStates.myPRBack === "Pending"
    ) {
      setStep("verifying");
    } else if (progressStates.myPRFront === "Not Started") {
      setStep("mypr-front-guideline");
    } else if (progressStates.myPRFront === "Fail") {
      setStep("mypr-front-rejected");
    } else if (progressStates.myPRBack === "Not Started") {
      setStep("mypr-back-guideline");
    } else if (progressStates.myPRBack === "Fail") {
      setStep("mypr-back-rejected");
    } else if (progressStates.blacklist === "Fail") {
      setStep("blacklist-rejected");
    } else if (progressStates.kenalID === "Fail") {
      setStep("kenal-id-rejected");
    }
    //  else if (
    //   progressStates.selfieWithMyPR === "Not Started" &&
    //   workflowConfig["Selfie With MyPR"]
    // ) 
    // {
    //   setStep("selfie-with-mypr-guideline");
    // } else if (progressStates.selfieWithMyPR === "Fail") {
    //   setStep("selfie-with-mypr-rejected");
    // } else if (
    //   progressStates.hologramDetection === "Not Started" &&
    //   workflowConfig["Hologram Detection"]
    // ) 
    // {
    //   setStep("hologram-detection-guideline");
    // } else if (progressStates.hologramDetection === "Fail") {
    //   setStep("hologram-detection-rejected");
    // }
     else {
      if (onComplete) {
        onComplete({
          validationID: validationID,
        });
      }
    }
  }, [progressStates, workflowConfig, validation]);

  const onNext = (currentStep) => {
    // From current step, determine which step to go next, based on workflow config and also progressStates.

    if (currentStep === "myPRFront") {
      if (
        progressStates.myPRBack === "Fail" ||
        progressStates.myPRBack === "Not Started"
      ) {
        setStep("mypr-back-guideline");
      } 
      // else if (
      //   workflowConfig["Selfie With MyPR"] &&
      //   (progressStates.selfieWithMyPR === "Fail" ||
      //     progressStates.selfieWithMyPR === "Not Started")
      // ) {
      //   setStep("selfie-with-mypr-guideline");
      // } else if (
      //   workflowConfig["Hologram Detection"] &&
      //   (progressStates.hologramDetection === "Fail" ||
      //     progressStates.hologramDetection === "Not Started")
      // ) {
      //   setStep("hologram-detection-guideline");
      // } 
      else {
        setStep("verifying");
      }
    } else if (currentStep === "myPRBack") {
      // if (
      //   workflowConfig["Selfie With MyPR"] &&
      //   (progressStates.selfieWithMyPR === "Fail" ||
      //     progressStates.selfieWithMyPR === "Not Started")
      // ) {
      //   setStep("selfie-with-mypr-guideline");
      // } else if (
      //   workflowConfig["Hologram Detection"] &&
      //   (progressStates.hologramDetection === "Fail" ||
      //     progressStates.hologramDetection === "Not Started")
      // ) {
      //   setStep("hologram-detection-guideline");
      // } 
      // else {
        setStep("verifying");
      // }
    } 
    // else if (currentStep === "selfieWithMyPR") {
    //   if (
    //     workflowConfig["Hologram Detection"] &&
    //     (progressStates.hologramDetection === "Fail" ||
    //       progressStates.hologramDetection === "Not Started")
    //   ) {
    //     setStep("hologram-detection-guideline");
    //   } else {
    //     setStep("verifying");
    //   }
    // } else if (currentStep === "hologramDetection") {
    //   setStep("verifying");
    // }
  };

  const renderSteps = () => {
    switch (step) {
      case "mypr-front-guideline":
        return (
          <Guideline
            myPRSide="front"
            positiveSampleImage={myprFrontGood}
            negativeSampleImage={myprFrontBad}
            onNext={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mypr-front-upload");
            }}
          />
        );
      case "mypr-front-upload":
        return (
          <UploadPhoto
            useOCRForData={autofillFromOCR}
            imageBuffer={userUploadImageBuffer}
            onSuccess={ async ({
              croppedImageBlob,
              originalImageBlob,
              // ocrName,
              // ocrIDNumber,
            }) => {
              setMyPRFrontImageBlob(croppedImageBlob);
              setMyPRFrontOriginalImageBlob(originalImageBlob);

              if (autofillFromOCR === true) {
                const formData = new FormData();
                formData.append("file", croppedImageBlob);
                const res = await extractNameAndIDNumber(formData);
                if (res.status === "success") {
                  setOcrName(res.data.name);
                  setOcrIDNumber(res.data.idNumber);
                }
              }
              setStep("mypr-front-check-quality");
            }}
            onError={(error, showImage = true) => {
              setTakePhotoErrorMessage({ text: error, showImage });
              setStep("mypr-front-upload-error");
            }}
          />
        );
      case "mypr-front-upload-error":
        return (
          <TakePhotoError
            errorMessage={takePhotoErrorMessage.text}
            showImage={takePhotoErrorMessage.showImage}
            imageBuffer={userUploadImageBuffer}
            onRetry={() => {
              setTakePhotoErrorMessage("");
              setStep("mypr-front-guideline");
            }}
          />
        );
      case "mypr-front-check-quality":
        return (
          <CheckQuality
            useOCRForData={autofillFromOCR}
            ocrName={ocrName}
            ocrIDNumber={ocrIDNumber}
            isSubmitting={isSubmitting}
            myPRSide="front"
            imageBlob={myPRFrontImageBlob}
            onRetake={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mypr-front-upload");
            }}
            onConfirm={() => {
              setIsSubmitting(true);
              setHasMyPRFrontCheckCompleted(false);

              const formData = new FormData();
              formData.append("validationID", validationID);
              formData.append("autofillFromOCR", autofillFromOCR);
              formData.append("originalImage", myPRFrontOriginalImageBlob);
              formData.append("croppedImage", myPRFrontImageBlob);

              if (autofillFromOCR === true) {
                formData.append("ocrName", ocrName);
                formData.append("ocrIDNumber", ocrIDNumber);
              }

              uploadFront(formData)
                .then((res) => {
                  onSessionUpdate?.(res.session);
                  if (res.status === "success") {
                    // Submitting for verification, and proceed to mypr back immediately
                    verifyFront({
                      validationID,
                    }).then((verifyRes) => {
                      onSessionUpdate?.(verifyRes.session);
                      setHasMyPRFrontCheckCompleted(true);
                    });
                    onNext("myPRFront");
                  }
                  setIsSubmitting(false);
                })
                .catch(() => {
                  setIsSubmitting(false);
                });
            }}
            onEditName={() => {
              setEditNameModal(true);
            }}
            onEditIDNumber={() => {
              setEditIDNumberModal(true);
            }}
          />
        );
      case "mypr-front-rejected":
        return (
          <MyPRReject
            validationID={validationID}
            myPRSide="front"
            onRetry={() => setStep("mypr-front-guideline")}
          />
        );
      case "mypr-back-guideline":
        return (
          <Guideline
            myPRSide="back"
            positiveSampleImage={myprBackGood}
            negativeSampleImage={myprBackBad}
            onNext={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mypr-back-upload");
            }}
          />
        );
      case "mypr-back-upload":
        return (
          <UploadPhoto
            imageBuffer={userUploadImageBuffer}
            onSuccess={({ croppedImageBlob, originalImageBlob }) => {
              setMyPRBackImageBlob(croppedImageBlob);
              setMyPRBackOriginalImageBlob(originalImageBlob);
              setStep("mypr-back-check-quality");
            }}
            onError={(error, showImage = true) => {
              setTakePhotoErrorMessage({ text: error, showImage });
              setStep("mypr-back-upload-error");
            }}
          />
        );
      case "mypr-back-upload-error":
        return (
          <TakePhotoError
            errorMessage={takePhotoErrorMessage.text}
            showImage={takePhotoErrorMessage.showImage}
            imageBuffer={userUploadImageBuffer}
            onRetry={() => {
              setTakePhotoErrorMessage("");
              setStep("mypr-back-guideline");
            }}
          />
        );
      case "mypr-back-check-quality":
        return (
          <CheckQuality
            isSubmitting={isSubmitting}
            myPRSide="back"
            imageBlob={myPRBackImageBlob}
            onRetake={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mypr-back-upload");
            }}
            onConfirm={() => {
              setIsSubmitting(true);
              setHasMyPRBackCheckCompleted(false);

              const formData = new FormData();
              formData.append("validationID", validationID);
              formData.append("originalImage", myPRBackOriginalImageBlob);
              formData.append("croppedImage", myPRBackImageBlob);

              uploadBack(formData)
                .then((res) => {
                  onSessionUpdate?.(res.session);
                  if (res.status === "success") {
                    // Submitting for verification, and proceed to verifiying screen immediately
                    verifyBack({
                      validationID,
                    }).then((verifyRes) => {
                      onSessionUpdate?.(verifyRes.session);
                      setHasMyPRBackCheckCompleted(true);
                    });

                    onNext("myPRBack");
                  }
                  setIsSubmitting(false);
                })
                .catch(() => {
                  setIsSubmitting(false);
                });
            }}
          />
        );
      case "mypr-back-rejected":
        return (
          <MyPRReject
            validationID={validationID}
            myPRSide="back"
            onRetry={() => setStep("mypr-back-guideline")}
          />
        );
      case "blacklist-rejected":
        return (
          <MyPRReject
            validationID={validationID}
            myPRSide="blacklist"
            onRetry={() => setStep("mypr-front-guideline")}
          />
        );
      case "kenal-id-rejected":
        return (
          <MyPRReject
            validationID={validationID}
            myPRSide="kenalID"
            onRetry={() => setStep("mypr-front-guideline")}
          />
        );
      // case "selfie-with-mypr-guideline":
      //   return (
      //     <GuidelineSelfieWithMyPR
      //       onNext={(imageBuffer) => {
      //         setUserUploadImageBuffer(imageBuffer);
      //         setStep("selfie-with-mypr-check-quality");
      //       }}
      //     />
      //   );
      // case "selfie-with-mypr-check-quality":
      //   return (
      //     <CheckQualitySelfieWithMyPR
      //       isSubmitting={isSubmitting}
      //       imageBuffer={userUploadImageBuffer}
      //       onRetake={(imageBuffer) => {
      //         setUserUploadImageBuffer(imageBuffer);
      //         setStep("selfie-with-mypr-check-quality");
      //       }}
      //       onConfirm={(imageBlob) => {
      //         setIsSubmitting(true);
      //         setHasSelfieWithMyPRCheckCompleted(false);
      //         const formData = new FormData();
      //         formData.append("validationID", validationID);
      //         formData.append("file", imageBlob);

      //         verifySelfieWithMyPR(formData)
      //           .then((res) => {
      //             setHasSelfieWithMyPRCheckCompleted(true);
      //             onNext("selfieWithMyPR");
      //             setIsSubmitting(false);
      //           })
      //           .catch(() => {
      //             setIsSubmitting(false);
      //           });
      //       }}
      //     />
      //   );
      // case "selfie-with-mypr-rejected":
      //   return (
      //     <MyPRReject
      //       validationID={validationID}
      //       myPRSide="selfieWithMyPR"
      //       onRetry={() => setStep("selfie-with-mypr-guideline")}
      //     />
      //   );
      // case "hologram-detection-guideline":
      //   return (
      //     <GuidelineHologramDetection
      //       onNext={(imageBuffer) => {
      //         setUserUploadImageBuffer(imageBuffer);
      //         setStep("hologram-detection-upload");
      //       }}
      //     />
      //   );
      // case "hologram-detection-upload":
      //   return (
      //     <UploadPhoto
      //       imageBuffer={userUploadImageBuffer}
      //       onSuccess={({ croppedImageBlob, originalImageBlob }) => {
      //         setMyPRHologramImageBlob(croppedImageBlob);
      //         setMyPRHologramOriginalImageBlob(originalImageBlob);
      //         setStep("hologram-detection-check-quality");
      //       }}
      //       onError={(error) => {
      //         setTakePhotoErrorMessage(error);
      //         setStep("hologram-detection-upload-error");
      //       }}
      //     />
      //   );
      // case "hologram-detection-upload-error":
      //   return (
      //     <TakePhotoError
      //       errorMessage={takePhotoErrorMessage}
      //       imageBuffer={userUploadImageBuffer}
      //       onRetry={() => {
      //         setTakePhotoErrorMessage("");
      //         setStep("hologram-detection-guideline");
      //       }}
      //     />
      //   );
      // case "hologram-detection-check-quality":
      //   return (
      //     <CheckQualityHologramDetection
      //       isSubmitting={isSubmitting}
      //       imageBuffer={myPRHologramImageBlob}
      //       onRetake={(imageBuffer) => {
      //         setUserUploadImageBuffer(imageBuffer);
      //         setStep("hologram-detection-upload");
      //       }}
      //       onConfirm={() => {
      //         setIsSubmitting(true);
      //         setHasHologramDetectionCheckCompleted(false);

      //         const formData = new FormData();
      //         formData.append("validationID", validationID);
      //         formData.append("croppedImage", myPRHologramImageBlob);
      //         formData.append("originalImage", myPRHologramOriginalImageBlob);

      //         verifyHologram(formData)
      //           .then((res) => {
      //             setHasHologramDetectionCheckCompleted(true);
      //             onNext("hologramDetection");
      //             setIsSubmitting(false);
      //           })
      //           .catch(() => {
      //             setIsSubmitting(false);
      //           });
      //       }}
      //     />
      //   );
      // case "hologram-detection-rejected":
        // return (
        //   <MyPRReject
        //     validationID={validationID}
        //     myPRSide="hologramDetection"
        //     onRetry={() => setStep("hologram-detection-guideline")}
        //   />
        // );
      case "verifying":
        return (
          <Verifying
            validationID={validationID}
            progressStates={progressStates}
            // workflowConfig={workflowConfig}
            hasMyPRFrontCheckCompleted={hasMyPRFrontCheckCompleted}
            hasMyPRBackCheckCompleted={hasMyPRBackCheckCompleted}
            // hasSelfieWithMyPRCheckCompleted={hasSelfieWithMyPRCheckCompleted}
            // hasHologramDetectionCheckCompleted={
            //   hasHologramDetectionCheckCompleted
            // }
            onSessionUpdate={onSessionUpdate}
            onPass={(checkResult) => {
              // If "In Review", proceed directly to next workflow step
              if (checkResult.overallStatus === "In Review") {
                onComplete({ validationID: validation?.ValidationID });
                return;
              }
              setProgressStates((prev) => ({
                ...prev,
                myPRFront: checkResult.front.status,
                myPRBack: checkResult.back.status,
                // selfieWithMyPR: checkResult.selfie
                //   ? checkResult.selfie
                //   : prev.selfieWithMyPR,
                // hologramDetection: checkResult.hologram
                //   ? checkResult.hologram
                //   : prev.hologramDetection,
              }));
              onNext("verifying");
            }}
            onFail={(checkResult) => {
              if (checkResult.validationCount >= 3) {
                return setStep("exceed-max-retry");
              }

              setTimeout(() => {
                setProgressStates((prev) => ({
                  ...prev,
                  myPRFront: checkResult.front.status,
                  myPRBack: checkResult.back.status,
                  blacklist: checkResult.blacklist
                    ? checkResult.blacklist
                    : prev.blacklist,
                  kenalID: checkResult.kenalID
                    ? checkResult.kenalID
                    : prev.kenalID,
                  // selfieWithMyPR: checkResult.selfie
                  //   ? checkResult.selfie
                  //   : prev.selfieWithMyPR,
                  // hologramDetection: checkResult.hologram
                  //   ? checkResult.hologram
                  //   : prev.hologramDetection,
                }));
              }, 2000);
            }}
          />
        );
      case "multiple-reject":
        return (
          <MultipleReject
            progressStates={progressStates}
            onRetry={() => {
              if (progressStates.myPRFront === "Fail") {
                setStep("mypr-front-guideline");
              } else if (progressStates.myPRBack === "Fail") {
                setStep("mypr-back-guideline");
              }
              //  else if (progressStates.selfieWithMyPR === "Fail") {
              //   setStep("selfie-with-mypr-guideline");
              // } else if (progressStates.hologramDetection === "Fail") {
              //   setStep("hologram-detection-guideline");
              // } 
              else if (progressStates.blacklist === "Fail") {
                setStep("mypr-front-guideline");
              } else if (progressStates.kenalID === "Fail") {
                setStep("mypr-front-guideline");
              }
            }}
          />
        );
      case "exceed-max-retry":
        return <ExceedMaxRetry />;
      case "invalid-token":
        return <InvalidToken />;
      default:
        // Return loading screen
        return <div>Loading...</div>;
    }
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 flex justify-center items-center">
      <div className="min-h-screen w-full max-w-md bg-transparent relative md:rounded-xl md:shadow-lg">
        {!token ? <InvalidToken /> : renderSteps()}

        <EditNameModal
          isOpen={editNameModal}
          initialName={ocrName}
          onClose={() => setEditNameModal(false)}
          onSave={(newName) => {
            setOcrName(newName);
            setEditNameModal(false);
          }}
        />

        <EditIDNumberModal
          isOpen={editIDNumberModal}
          initialIDNumber={ocrIDNumber}
          onClose={() => setEditIDNumberModal(false)}
          onSave={(newIDNumber) => {
            setOcrIDNumber(newIDNumber);
            setEditIDNumberModal(false);
          }}
        />
      </div>
    </div>
  );
};

export default MyPR;
